export default __webpack_public_path__ + "static/media/logo.0baf9b22.svg";